import { useEffect } from "react";
import { showAppOutdatedToast } from "@Core/components/VersionToastInfo/showAppOutdatedToast";
import { APP_VERSION, CHECK_APP_VERSION } from "@config/app";

export function useVersionCheck(interval = 5 * 60 * 1000) {
  useEffect(() => {
    if (!CHECK_APP_VERSION) {
      return;
    }

    const currentVersion = APP_VERSION;

    const checkVersion = async () => {
      try {
        const response = await fetch("/meta.json", { cache: "no-store" });
        const { version: serverVersion } = await response.json();

        if (serverVersion && serverVersion !== currentVersion) {
          showAppOutdatedToast();
        }
      } catch (err) {
        console.warn("Version check failed:", err);
      }
    };

    const intervalId = setInterval(checkVersion, interval);

    return () => {
      clearInterval(intervalId);
    };
  }, [interval]);
}
